import { NgModule } from "@angular/core";
import { EfxBreadcrumbModule } from '@signal/component-library/efx-breadcrumb';
import { EfxAccordionModule } from '@signal/component-library/efx-accordion';
import { EfxAlertModule } from '@signal/component-library/efx-alert';
import { EfxBadgeModule } from '@signal/component-library/efx-badge';
import { EfxCheckboxFieldModule } from "@signal/component-library/efx-checkbox-field";
import { EfxDataTableModule } from "@signal/component-library/efx-data-table";
import { EfxDropdownModule } from '@signal/component-library/efx-dropdown'
import { EfxFooterModule } from "@signal/component-library/efx-footer";
import { EfxHeaderDropdownPanelModule, EfxHeaderIconButtonModule, EfxHeaderLogoModule, EfxHeaderModule, EfxHeaderSectionModule,EfxHeaderSubmenuLinkModule } from "@signal/component-library/efx-header";
import { EfxMenuModule } from "@signal/component-library/efx-menu";
import { EfxModalModule } from "@signal/component-library/efx-modal";
import { EfxPagerModule } from "@signal/component-library/efx-pager";
import { EfxPageSizeSelectorModule } from "@signal/component-library/efx-page-size-selector";
import { EfxProgressTrackerModule } from '@signal/component-library/efx-progress-tracker';
import { EfxRadioGroupFieldModule } from '@signal/component-library/efx-radio-group-field'
import { EfxSlideToggleModule } from '@signal/component-library/efx-slide-toggle';
import { EfxSpinnerModule } from '@signal/component-library/efx-spinner';
import { EfxTextAreaModule } from "@signal/component-library/efx-text-area";
import { EfxTextFieldModule } from "@signal/component-library/efx-text-field";
import { EfxTooltipModule } from "@signal/component-library/efx-tooltip";
import { EfxTabsModule } from '@signal/component-library/efx-tabs';
import { EfxDateRangePickerModule } from '@signal/component-library/efx-date-range-picker'
import { EfxToastModule } from '@signal/component-library/efx-toast';
import { EfxNotificationBadgeModule } from '@signal/component-library/efx-notification-badge';
import { EfxTypeAheadModule } from '@signal/component-library/efx-type-ahead';


import {
  EfxTextFieldFilterModule
} from '@signal/component-library/efx-data-table-filter';

const EXPORTS = [
  EfxAccordionModule,
  EfxAlertModule,
  EfxBadgeModule,
  EfxCheckboxFieldModule,
  EfxDataTableModule,
  EfxDropdownModule,
  EfxFooterModule,
  EfxHeaderDropdownPanelModule,
  EfxHeaderIconButtonModule,
  EfxHeaderLogoModule,
  EfxHeaderModule,
  EfxHeaderSectionModule,
  EfxMenuModule,
  EfxModalModule,
  EfxPagerModule,
  EfxPageSizeSelectorModule,
  EfxProgressTrackerModule,
  EfxRadioGroupFieldModule,
  EfxSlideToggleModule,
  EfxSpinnerModule,
  EfxTextAreaModule,
  EfxTextFieldModule,
  EfxTooltipModule,
  EfxTabsModule,
  EfxDateRangePickerModule,
  EfxTextFieldFilterModule,
  EfxBreadcrumbModule,
  EfxToastModule,
  EfxHeaderSubmenuLinkModule,
  EfxNotificationBadgeModule,
  EfxTypeAheadModule
];

@NgModule({ exports: EXPORTS })
export class SignalDesignModule { }
